import useImpersonatorOrganization from "./useImpersonatorOrganization"

export function useIsPartnerTenant() {
  const { value: actingTenant } = useImpersonatorOrganization()
  return actingTenant?.organization.type === "reseller"
}
